import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import getInitialState from './initialState';

export default {
  namespaced: true,
  state: getInitialState(),
  actions,
  getters,
  mutations
};
